import { render } from "./faq.vue?vue&type=template&id=74aaf9ce&scoped=true"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"

import "./faq.vue?vue&type=style&index=0&id=74aaf9ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74aaf9ce"]])

export default __exports__